export default __webpack_public_path__ + "static/media/Logo_facebook.393fbeea.svg";